module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-14"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("E")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("LIZABETH")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ARRIVED")]), _vm._v(" at the diner when the sky was still a dark grayish-blue with only a hint of pink in the direction of the unrisen sun. Even the roosters had enough sense to keep sleeping, but here she stood. Waiting for Rick to come down and let her in to the diner to start their...what had he called it? Small-town education?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She lightly tapped her cheeks in an effort to wake herself. This tired feeling was more than jet lag. She’d dealt with that often enough to be immune to its effects. Maybe it was the déjà vu being in a small town had brought out. She’d grown up in hick towns; her mother worked restaurant jobs with their low wages, meager tips and free food. And the chance that Elizabeth could sit in a booth for a few hours so her mom didn’t have to pay a babysitter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before she could plumb her past any further, the door opened and Rick stood there smiling at her. He should look as tired as she felt, but instead he beamed at her as he ushered her inside. “Ready for your first look at my life?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stifled a yawn and nodded. “Does the first look have to come so early?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My day usually starts an hour before this, but I thought I’d give you a break.” He leaned toward her, and for a brief moment she wondered if he was going to kiss her. He reached past to turn the sign on the door to Open.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He motioned for her to follow him, and she walked behind him into the kitchen. Savory smells of bacon and sausage assaulted her, making her stomach growl. What she wouldn’t give for a sausage patty right now. He opened an oven door, peered in, then adjusted the temperature. When he turned back to face her, he frowned. “Why are you wearing that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She glanced down at the outfit she had painstakingly chosen for their day: one of her best power suits in cherry-red and teetering black heels. “I believe you mentioned I’d be meeting people from your town.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nodded. “And they’ll eat you alive wearing that. Don’t you own a pair of jeans?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Denim wasn’t exactly a staple in her wardrobe, but glancing at what Rick was wearing told her it was a part of his. She wiped at an imaginary smudge on her skirt. “I’m sure your friends will appreciate good taste.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The grease will ruin that fancy getup within the hour. Go back to your hotel and change.” He turned his back to her and started whisking eggs with flour.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Grease?")]), _vm._v(" There’d been no mention of that when they’d made plans for today. What exactly was he planning? “You don’t expect me to actually work here, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick turned back to her with a dazzling smile. It was easy to see why the cameras fell in love with him. “You wanted a glimpse into my life, right? Since Mom handed the diner over to me, I’m here twelve hours a day, six days a week. So that’s where we’re starting.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She crossed her arms across her chest. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nope. Not happening.")]), _vm._v(" “You don’t have anyone to cover for you today?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s the Lake Mildred Pickle Festival. Busiest weekend of the summer. I’m going to be swamped with orders in about ten minutes and won’t get a break until after the Ladies’ Book Club finishes their last cup of coffee.” He continued to whisk and paused only to add more flour.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She glared, hoping that the effect would turn him into stone. “I thought you were the owner and manager here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m whatever they need me to be. Besides, it’s fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sigh.")]), _vm._v(" Not her idea of fun. “And I’m supposed to help you out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s the idea, Lizzie.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She grumbled on the drive back to the bed-and-breakfast to change into the outfit she’d least likely have a fit over if it got ruined. She fumed as she drove back to the diner and parked behind it, where the employees left their cars. And she moaned when Rick threw a clean apron at her and pointed to the stack of dishes that had accumulated in her absence. “Washing dishes? Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick started to whistle as he placed slices of bread in a large toaster and pressed the lever. “It’s where all good cooks start.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But I’m not a cook,” she muttered under her breath. She couldn’t even make toast without setting off the smoke detectors in her apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wrinkled her nose at the dried gobs of egg and grease on the first plate. There had to be better ways to get Rick to do the show than this. She glanced behind her at the man in question, who cracked eggs onto the hot griddle. If she could just find out why he’d done the show the first time...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dishes don’t wash themselves, Lizzie.” He threw the eggshells into the large trash can next to him as if they were basketballs and he were Kobe Bryant. He walked over and turned on the hot water, then squeezed a healthy dollop of dish soap into the sink. Pointed to the three sinks, the last full of clear liquid. “Wash. Rinse. Sanitize.” He pulled the hose closer to her. “And don’t be afraid to get a little wet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She rolled her eyes and dropped the first dish into the sudsy water.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("R")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ICK")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("SWALLOWED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("A")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("LAUGH")]), _vm._v(" as Lizzie glared at him over her coffee cup. She looked like a drowned rat. Her long brown hair was plastered to the sides of her head; her clothes clung to her slight form. Her carefully applied makeup had run two hours ago, leaving her face streaked in brown and blue. “Good job, Lizzie.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She rolled her eyes and forked a bite of French toast into her mouth, pausing to moan after the first bite. “What do you put in these?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shrugged. “Little cinnamon. Lots of love.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Again with the rolled eyes. She’d be lucky to end the day without a massive headache if she kept that up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So are you done torturing me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Torture.")]), _vm._v(" Interesting word choice. She’d agreed to get a glimpse of his normal life, and now she considered it inhumane. If only she knew. “You’ll probably want to freshen up before the lunch crowd gets here.” Panic washed over her face, but he held up one hand. “Don’t worry. You’re done with the dishes. Jeffy should be here anytime.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her shoulders relaxed. “Thank goodness.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But I am short a waitress.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lizzie stood up and threw her napkin on the table before storming out of the diner. Rick chuckled and took another sip of his coffee. Mission accomplished. Better that she leave now than wait until it was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The bell above the door chimed again. “Ricky.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He glanced up and swallowed a groan at the sight of his older brother, Dan, wearing a suit and tie. If Mr. High and Mighty stooped to grace the diner with his presence, the news couldn’t be good. Didn’t matter that the diner belonged to the family empire along with the pickle-canning plant and brightly colored cans of pickles on store shelves. Rick knew that the diner didn’t even register on Dan’s radar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Need a cup of coffee?” Rick stood and retrieved the coffee carafe from behind the counter, hooked a mug with one finger, then joined his brother in the back booth. He poured the coffee into the empty mug before topping off his own. “Still drink it black or should I find the creamer?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Black’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick nodded and took the seat across from Dan. “What’s wrong? Is it Mom again?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan shook his head, then glanced behind him at the customers gathered at the diner. “We can talk here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Any news his brother had to share would be sure to make the gossip rounds in Lake Mildred before too long. “Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan sighed, rubbing the space between his eyebrows. “I’ll be glad when this whole economic downturn is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Downturn?")]), _vm._v(" Was that what people losing their jobs, homes and lives was? Rick took a sip of his coffee, mostly to keep from saying what he really wanted to say. “Just tell me what you came here for.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan leaned forward. “I heard that producer is in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Biting the inside of his cheek, Rick nodded. So that was what his visit was about? A pretty face? “Yeah, Lizzie’s here. She might be back in about twenty minutes if you want to talk to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan frowned. “Why would I talk to her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s cute. All wrong for you, of course. But she does fit your type.” Rick poured some creamer into his coffee and stirred it. “Smart. Pretty. No nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not looking for a date, Rick.” He took a sip of his coffee, then placed the mug on the table. Rubbed his forehead and twitching eye. “She wants you to do that show again?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He sighed. He couldn’t escape the show, not even with his family. “Don’t worry. I already told her to forget about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan frowned and shook his head as if Rick had said the worst thing in the world. “Why would you do a stupid thing like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Wait.")]), _vm._v(" His brother wanted him to do the show? “If memory serves, you didn’t want me to do the show the last time. Hated it when I left. Then resented me when I came back home.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was stupid, okay?” He glanced at his cell phone. “All of Dad’s talk about what was good for the family? The company? I think I get it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick remembered the discussions he and his dad had had over the show. In the end, it had come down to Rick choosing to help save the family company. “You got it five years too late.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wasn’t CEO then. I didn’t realize what a boon that show could be.” Dan adjusted the lapel of his suit coat. “Last time, our sales went up almost thirty percent. We got distributors in a dozen more states that sold our product. Business at the diner tripled after they aired your hometown visit.” He leaned in closer. “We could use that kind of publicity again.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan shook his head. “What’s changed? Dad told you to do the show then. I’m telling you now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Telling him what to do yet again. Well, Rick wasn’t the same little brother who went along with Dan’s ideas. He had his own life. His own choices to make. “I’m smarter this time around. I won’t do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I get it.” Dan jutted his jaw forward, the same way he had since they were kids and he thought he was not only right, but that Rick would be convinced of it, too. “You need to think about it. I’ll call you in a few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Call me next week. The answer will still be the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dan stood and placed a hand on Rick’s shoulder. “You’ve got to think of the family, little brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick shook his head and bit back a laugh. “I am thinking of the family. You’re focusing on the company’s bottom line.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t understand the hole we’re in. And if we fail, this town will never be the same—” Dan broke off and shook his head. “Never mind. This was a mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick got to his feet and leaned in toward Dan. “Why would we fail?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe if you read those company reports I send you more than you read the sports pages, you might understand why I’m here.” Dan took one last sip of coffee before slapping the mug on the table. “Thanks for the coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick was getting pretty good at making people storm out of his diner.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("E")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("LIZABETH")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("STARED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("INTO")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("her suitcase as if a waitress uniform would magically appear. Thankfully, she’d never had to go the same route as her mother. She’d known someone who knew someone offering a job as a page on a studio lot when she turned sixteen, and she’d been into television ever since. It was all that she knew. All she wanted. That was why she had to use this week to convince Rick to do the show. If that meant washing mountains of dishes and pouring rivers of coffee, she’d do it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A pair of khakis peeked at her from the bottom of the suitcase, so she pulled them out and found a sleeveless green shell and matching short-sleeved top to go with it. It was better than nothing. Or at least better than the sopping oxford and slacks that hung over the shower curtain rod in the tiny bathroom of her room at the bed-and-breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She returned to the diner to find Rick barking orders to his cook through the window. He looked comfortable here. As if he knew that he’d be doing this for the rest of his life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Unfortunately.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Didn’t he see that he had so much more to offer? She’d watched the dailies again from the last show he’d done and knew that he was made for bigger things than running a small-town diner. Maybe he didn’t want to work for the family company, but he wasn’t being challenged here. That was where she came in. She needed to broaden his horizons. Provide him with a better life. Success on the show would mean opened doors for him, and he could write his own future. Be a celebrity chef if he wanted. Get his own cooking show and endorsement deals.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m back.” She did a Vanna White impression and turned around. “Will this suffice for a waitress?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick looked her up and down, then grimaced. “You sure you want grease to touch that silk shirt?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s either this or another suit.” She put her hands on her hips. “I didn’t exactly plan on working at the diner this entire week with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The diner is my life now.” He looked at her outfit again. “We’ll go shopping after lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She could handle shopping. That thought might get her through whatever he had in store for her. “Is that part of my small-town education?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick grinned and handed her a clean apron to tie around her hips and a blank order pad. “I’ll help you with the first three tables, and then you’re on your own. Got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She produced a popular television show and made it look easy. How hard could this be? “I think I can handle taking a few orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Again with the smile. Why did she get the feeling that there was more to this?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll still help you with the first three. They can be tricky.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick chose the first table of two older women, who chatted with each other more than glancing at their menus. Elizabeth approached them. “Good afternoon, ladies. What can I get you today?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Talk ceased as they turned to look at her. Perused her outfit. Glanced at Rick. Then sighed collectively. The woman with salt-and-pepper hair spoke first. “Well, aren’t you the cutest thing?” She turned to Rick. “Where did you find her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick stepped forward and clasped his hands behind his back. “She’s just helping out a few days for the Pickle Festival. So be gentle with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The two women gave each other telling glances. The fading redhead turned to Elizabeth. “What soups do you have today?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Elizabeth glanced at the back of her order pad, where she’d written them. “Chicken noodle. Clam chowder. And vegetable.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The women resumed looking at their menus. The salt-and-pepper looked up at Rick. “Char’s coming in for the festival this weekend, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick gave a tight smile. “You must be looking forward to seeing your daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Elizabeth glanced at him. He tugged at the collar of his T-shirt and rolled his head on his shoulders. Clearly not a good topic.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What she’s looking forward to is seeing you again, Rick. Should I tell her to give you a call?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick shifted on his feet until Elizabeth stepped in. “Actually, he’ll be busy with me this weekend. Working the festival and all.” She glanced at Rick. “Isn’t that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick sighed and nodded. “Yeah, that’s right. It’s gonna be pretty busy, Mrs. Stanfill.” When the older woman wrinkled her nose, he quickly added, “But I’ll be sure to say hello if I see her in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Red gave her friend a sideways glance, then offered a big smile to Rick. “Donna will be in town, as well. You be sure to say hello to her, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick nodded, but he looked as if he’d agreed to pour salt into old wounds. “Elizabeth, why don’t you go ahead and take their orders? I’ve got to check on something in the kitchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick left her standing alone. She took a big breath. “So what can I get you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("E")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("LIZABETH")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("WAS")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("CONVINCED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("that he’d chosen the three most difficult tables to train her on. They all wanted specific orders rather than something off the menu. Maybe he’d put them up to it. Maybe he’d told them to be difficult. She groaned and hoisted the tray of food for the second table onto her shoulder like Rick had shown her. It was heavier than it looked, and she almost sagged under its weight. A drop of oil dripped from the tray onto her blouse.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Great.")]), _vm._v(" She’d definitely need that trip to the clothing store. How did people not have to buy a wardrobe at the end of the day working in food service? If nothing else, she would appreciate how hard her server worked the next time she ate at a restaurant. She promised she’d tip better if she could get through this afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("By the end of the lunch rush, she found herself again at the back booth, her feet up and resting on the seat across from her. She’d developed blisters. She must have the way her feet throbbed and ached. She needed better shoes. New clothes. What else would this glimpse into Rick’s life cost her?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Here.” Rick set a plate laden with a BLT and fries in front of her. “My specialty, just for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wrinkled her nose at the bacon but one whiff of the sandwich made her stomach grumble loud enough for Rick to hear. He chuckled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks.” She laid a napkin on her lap and took a tentative bite.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mmmmmmmm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick grinned and left, only to return momentarily with his own sandwich. “Mind if I join you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Think the diner will survive without us?” She took another large bite and tried to chew faster to get to the next one.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think we have time to eat. You don’t have to rush.” He looked around the dining room, which held a few stragglers left from the rush. “Shirley’s here, so she can take over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Elizabeth took another bite of her sandwich and groaned again in delight. There was something different about the bacon. “What’s your secret?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If I told you, then it wouldn’t be a secret anymore.” He smirked at her. “I bake the bacon rather than frying it. Sprinkle it with Cajun seasonings and brown sugar to give it a little something special.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wiped her mouth with her napkin. “This is fantastic.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They ate in silence until Elizabeth pushed her plate away. It held only a few of the fries and a stray piece of lettuce. She patted her very full belly. “I can’t eat another bite. What are you trying to do to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked her over. “You could use some fattening up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Now you sound like a grandmother.” Not that she’d ever known one personally. Yet another part of childhood she’d missed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rick stuffed the rest of his sandwich in his mouth. They smiled at each other, not saying a word. Not needing to. When he was finished, he wiped his mouth and rubbed his flat stomach. “That really hit the spot.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It felt good to sit. To put her feet up and relax. She almost hated to ask, but she did. “So what’s next on the agenda?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I show you around town. The Pickle Festival kicks off tonight, so what better way to see it than that? The rides. The food. The people.” He winked at her. “You won’t be able to resist.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If only that were true. “Even if we agree to tape here, you’ll still have to come to L.A. for the live finale. That’s a tradition we can’t break.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not asking to break anything. Just change it a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Elizabeth nodded, then attempted to get to her feet, which protested. She sat back down. “As long as we’re not talking about long walks anywhere, I’m in.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-9"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 84
// module chunks = 0